module.exports = __webpack_public_path__ + "static/media/meditation8.545766cf.mp3";